import styled from "styled-components";

export const MainContainer = styled.div`
  .grid-view {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    gap: 10px;
    height: 100%;
    padding-right: 3rem;
  }

  .no-data {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--gray-contentoh);
  }

  .grid {
    justify-content: flex-start;
  }

  .table {
    display: flex;
    flex-direction: column;
    width: 100%;
  }
  .modal-cart {
    .custom-component {
      margin-top: 10px;
    }
    .btn-adquirir {
      border: 1px solid var(--pink-contentoh);
      background: var(--pink-contentoh);
      color: var(--white-contentoh);
      border-radius: 30px;
      padding: 4px 8px;
      cursor: pointer;
      &:hover {
        border: 1px solid var(--pink-contentoh);
        background: var(--white-contentoh);
        color: var(--pink-contentoh);
      }
    }
    .btn-cancelar {
      border: 1px solid var(--pink-contentoh);
      background: var(--white-contentoh);
      color: var(--pink-contentoh);
      border-radius: 30px;
      cursor: pointer;
      padding: 4px 8px;
      &:hover {
        border: 1px solid var(--pink-contentoh);
        background: var(--pink-contentoh);
        color: var(--white-contentoh);
      }
    }
  }
`;

export const GridSkeletonList = styled.ul`

  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
  gap: 2rem;
  padding: 0.5rem 2rem 0 0;

`;

export const GridSkeleton = styled.div`

  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border: 1px solid #eee;
  border-radius: 8px;

  .top {
    padding: 1rem 0.75rem 1rem;
  }

    .image {
      width: 100%;
      height: 9rem;
    }

    .information {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
      padding-top: 1rem;
    }

  .bottom {
    border-top: 1px solid #eee;
    padding 0 0.75rem 0.75rem;
    padding-top: 0.5rem;

    .progress {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 1rem;
      padding-bottom: 0.5rem;
    }

  }

`;